// Copyright 2019 Drivetrain Hub LLC
// GraphQL requests module index.
// https://vuejs.org/v2/guide/plugins.html

// Cannot type hint PluginObject without losing variable resolution.
// eslint-disable-next-line no-unused-vars
import { PluginFunction } from "vue";
import lib from "./modules/lib";
import model from "./modules/model";
import session from "./modules/session";
import tool from "./modules/tool";
import gear from "./modules/gear";
import eng from "./modules/eng";
import cad from "./modules/cad";

/** @alias $requests */
const Requests = {
  lib: lib,
  model: model,
  session: session,
  tool: tool,
  gear: gear,
  eng: eng,
  cad: cad,
};

/** @type {PluginFunction} */
Requests.install = function(Vue) {
  Object.defineProperty(Vue.prototype, "$requests", {
    get () { return Requests }
  })
};

export default Requests
